import type { ReactNode } from 'react';
import { Inbox, TriangleAlert } from 'lucide-react';

export function LoadingState({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="grid place-items-center py-12 text-sm text-[var(--muted-foreground)]">
      {label}
    </div>
  );
}

export function EmptyState({ title, hint, action }: { title: string; hint?: string; action?: ReactNode }) {
  return (
    <div className="grid place-items-center gap-1.5 py-12 text-center">
      <Inbox className="h-6 w-6 text-[var(--muted-foreground)] opacity-60" />
      <p className="text-sm font-medium">{title}</p>
      {hint && <p className="max-w-sm text-xs text-[var(--muted-foreground)]">{hint}</p>}
      {action}
    </div>
  );
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="grid place-items-center gap-1.5 py-12 text-center">
      {/* Semantic warning tone, deliberately unchanged by the rebrand. */}
      <TriangleAlert className="h-6 w-6 text-amber-500" />
      <p className="text-sm">{message}</p>
      {onRetry && (
        <button onClick={onRetry} className="text-sm text-[var(--accent)] underline">
          Try again
        </button>
      )}
    </div>
  );
}
